import { DetailedHTMLProps, FunctionComponent, HTMLAttributes } from "react";
import { Theme } from "..";
import TextAlignWrapper, { TextAlign } from "../TextAlignWrapper";
import styles from "./styles.module.scss";

export type BasicTextProps = DetailedHTMLProps<HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement> & {
  bold?: boolean,
  textAlign?: TextAlign,
  theme?: Theme
};

const BasicText: FunctionComponent<BasicTextProps> = ({ className, bold, children, theme, textAlign, ...props }: BasicTextProps) => {
  return (
    <TextAlignWrapper textAlign={textAlign ?? TextAlign.Left}>
      <p className={`${styles.basicText} ${bold === true ? styles.bold : ""} ${styles[theme ?? Theme.Light]} ${className ?? ""}`} {...props}>
        {children}
      </p>
    </TextAlignWrapper>
  );
};

export default BasicText;